const getters = {
  getColor: (state) => state.color,
  getImage: (state) => state.image,
  getTimer: (state) => state.timer,
  getInterest: (state) => state.interest,
  getPayments: (state) => state.payments,
  getFreeFreight: (state) => state.free_freight,
  getEmailRequired: (state) => state.email_required,
}

export default getters
